import MetadataDrivenUtil from 'gw-portals-driven-ui-js/MetadataDrivenUtil';
import MetadataDrivenParser from 'gw-portals-driven-ui-js/MetadataDrivenParser';
import ComponentUtil from 'gw-portals-util-js/ComponentUtil';
import MockUpUtil from 'gw-portals-util-js/MockUpUtil';
import DateUtil from 'gw-portals-util-js/DateUtil';
import _ from 'lodash';

const customMockDataSet = MetadataDrivenUtil.getPAS() === 'insuranceNow' ? 'insuranceNow' : undefined;
const mockUpUtil = new MockUpUtil({customMockDataSet});

let submissionVm;
let _MetadataDrivenUIService;
let _DriverLicenseUtil;
let _ModalService;

class PAContactDetailsCtrl {

    constructor($scope, AgeAllowedToDrive, DriverLicenseUtil, submissionViewModel, MetadataDrivenUIService, ModalService) {
        submissionVm = submissionViewModel();
        _MetadataDrivenUIService = MetadataDrivenUIService;
        _DriverLicenseUtil = DriverLicenseUtil;
        _ModalService = ModalService;

        this.$scope = $scope;
        this.ageAllowedToDrive = AgeAllowedToDrive;
        this._setCtrlParam = ComponentUtil.setCtrlParam(this, $scope);

        this._init();
    }

    _init() {
        this.baseDataViewModel = submissionVm.baseData;
        this.lobDataViewModel = submissionVm.lobData;
        this.baseDataViewModel.policyAddress.addressType.value = this.baseDataViewModel.policyAddress.addressType.value || 'home';

        this.$scope.documents = [];
        this.metadataTemplate = {
            docUID: '001',
            documentType: 'letter_received',
            securityType: 'unrestricted',
            status: 'approved'
        };

        // In streamlined quote we ask the driver for their age and use this as a base for the year they were born to create a submission.
        // However, in the full quote flow, we do not want to use this DOB that we quote with as it will not be the correct exact date.
        // We check to see if the user has been mocked or not, if they have then we set the accountHolders DOB to be undefined.
        if (mockUpUtil.isAccountHolderMocked(this.baseDataViewModel.accountHolder.value)) {
            this.baseDataViewModel.accountHolder.dateOfBirth = undefined;
        }

        mockUpUtil.cleanUpMockedProperties('baseData.accountHolder', this.baseDataViewModel.accountHolder.value, 'prefix', 'firstName', 'lastName', 'emailAddress1', 'dateOfBirth');
        mockUpUtil.cleanUpMockedProperties('baseData.policyAddress', this.baseDataViewModel.policyAddress.value, 'addressLine1', 'city');

        this.$scope.$watchCollection(() => this.baseDataViewModel.accountHolder.dateOfBirth, this.dateOfBirthChanged());

        this.isMetadataDrivenUIEnabled = MetadataDrivenUtil.isStepEnabled('pa', 'pa-contact-details');
        if (this.isMetadataDrivenUIEnabled) {
            this._metadataDrivenUI();
        } else {
            this._nonMetadataDrivenUI();
        }

        this.documentWatchCollection();

        this.next = (nextFn, form) => {
            nextFn(submissionVm, form);
        };
    }

    _cleanUpMockedData(uiMetadata) {
        const propertiesToCleanUp = [
            'baseData.accountHolder.prefix',
            'baseData.accountHolder.firstName',
            'baseData.accountHolder.lastName',
            'baseData.accountHolder.emailAddress1',
            'baseData.accountHolder.dateOfBirth',

            'baseData.policyAddress.addressLine1',
            'baseData.policyAddress.city'
        ];

        mockUpUtil.cleanUpMockedPropertiesUsingMetadata(this, {uiMetadata, propertiesToCleanUp});
    }

    /**
     * Build the page using the metadata driven ui and setting default values
     * @private
     */
    _metadataDrivenUI() {
        this.loading = true;

        _MetadataDrivenUIService.getPresentationMetadata('quoteandbind-pa.{SEGMENT}.contactDetails').then(contactDetailsPresentationMetadata => {
            contactDetailsPresentationMetadata = new MetadataDrivenParser(contactDetailsPresentationMetadata, submissionVm).parsePageContent();
            this._setCtrlParam('presentationData', contactDetailsPresentationMetadata);
            this._cleanUpMockedData(contactDetailsPresentationMetadata);
            this._setCtrlParam('loading', false);
        });
    }

    /**
     * Build the page using default architecture
     * @private
     */
    _nonMetadataDrivenUI() {
        this.isDriverLicenseZipcodeMismatch = false;
        this.postalCodeReadonly = angular.isDefined(this.baseDataViewModel.policyAddress.postalCode.value);
        this.stateReadonly = angular.isDefined(this.baseDataViewModel.policyAddress.state.value);
        this.accountHolder = this.baseDataViewModel.accountHolder.value;
        this.today = DateUtil.currentDateAtMidnight();
        this.maxDateOfBirth = {
            year: this.today.getFullYear() - this.ageAllowedToDrive,
            month: this.today.getMonth(),
            day: this.today.getDate()
        };
        this.accountHolder.primaryPhoneType = null;
        this.baseDataViewModel.policyAddress.addressType.value = this.baseDataViewModel.policyAddress.addressType.value || 'home';
        this._cleanUpMockedData();
    }

    /**
     *
     * When coming from Streamlined Quote, we create a dummy driver as part of the dummy submission. This driver will
     * also be the primary account holder. To ensure that the primary driver and the account holder are in sync we must
     * have a watch on the dateOfBirth field, any change to the account holder dob will update the associated driver dob.
     *
     * @returns {Object}
     */
    dateOfBirthChanged() {
        return () => {
            if (angular.isDefined(this.lobDataViewModel.personalAuto.coverables)) {
                const drivers = this.lobDataViewModel.personalAuto.coverables.drivers;
                if (drivers && drivers.length > 0) {
                    const paDriver = _.find(drivers.value, {isPolicyHolder: true});
                    if (angular.isDefined(paDriver)) {
                        paDriver.dateOfBirth = angular.copy(this.baseDataViewModel.accountHolder.dateOfBirth.value);
                    }
                }
            }
        };
    }

    /**
     *
     * Initializes a watch on documents. This functionality is triggered when a drivers licence document has
     * been uploaded. It populates the fields with the information from the uploaded drivers licence.
     */
    documentWatchCollection() {
        this.$scope.$watchCollection('documents', driverLicenses => {
            const accountHolder = this.baseDataViewModel.accountHolder;
            if (driverLicenses.length >= 1) {
                const driverLicenseData = driverLicenses.pop();
                _DriverLicenseUtil.setLicenseUploadProperties(accountHolder, driverLicenseData);
                if (!accountHolder.errorUploading) {
                    const postalCode = this.baseDataViewModel.policyAddress.postalCode.value;
                    this.isDriverLicenseZipcodeMismatch = driverLicenseData.primaryAddress.postalCode !== postalCode;
                    if (this.isDriverLicenseZipcodeMismatch) {
                        _ModalService.showError(
                            'quoteandbind.controllers.ContactDetailsCtrl.Error',
                            'quoteandbind.views.contact-details.We could not determine your address because the ZIP code on your license does not match the one you entered to start the quote. Please enter your address manually.'
                        );
                    } else {
                        _DriverLicenseUtil.fillContactInfo(accountHolder, driverLicenseData);
                    }
                } else {
                    _ModalService.showError(
                        'quoteandbind.views.contact-details.Something went wrong while scanning the driver license.',
                        'quoteandbind.views.contact-details.Information is incorrect or missing?'
                    );
                }
            }
        });
    }
}

PAContactDetailsCtrl.$inject = ['$scope', 'AgeAllowedToDrive', 'DriverLicenseUtil', 'submissionViewModel', 'MetadataDrivenUIService', 'ModalService'];

export default PAContactDetailsCtrl;